export function dealFromPermutation(deckOrder, plan, table, dealer) {
    const holdings = Array.from({ length: table.seatCount }, () => []);
    const kitty = [];
    let i = 0;
    const first = (dealer + plan.firstSeatOffset) % table.seatCount;
    for (const step of plan.steps) {
        if ('each' in step) {
            for (let s = 0; s < table.seatCount; s++) {
                const seat = (first + s) % table.seatCount;
                for (let n = 0; n < step.each; n++) {
                    holdings[seat].push(deckOrder[i++]);
                }
            }
        }
        else {
            for (let n = 0; n < step.kitty; n++)
                kitty.push(deckOrder[i++]);
        }
    }
    return {
        deckOrder,
        holdings: holdings.map((h) => Object.freeze([...h])),
        kitty: Object.freeze([...kitty]),
        stock: Object.freeze(deckOrder.slice(i)),
    };
}
export function cardsDealtBy(plan, seatCount) {
    return plan.steps.reduce((n, s) => n + ('each' in s ? s.each * seatCount : s.kitty), 0);
}
//# sourceMappingURL=deal.js.map